import type {
    ApiLogData,
    ApiLoggingAdapterInterface
} from '@scorewarrior/rubens_web_lib/lib/utility/api-logging-adapter-interface';
import consoleLogger from '../logger/consoleLogger';

const logger = consoleLogger.getPrefixedCopy('PAYSERVICE');

export const payServiceLoggingAdapter: ApiLoggingAdapterInterface = {
    logErrorResponse(requestData: ApiLogData, error: Error, asInfo?: boolean): void {
        if (asInfo) {
            logger.info('error response', requestData.method, requestData.url, error);
            return;
        }

        logger.error('error response', requestData.method, requestData.url, error);
        window.Sentry.captureException(error);
    },

    logException(requestData: ApiLogData, error: Error): void {
        logger.error('exception', requestData.method, requestData.url, error);
        window.Sentry.captureException(error);
    },

    logRequest(requestData: ApiLogData, data: unknown): void {
        logger.info('request', requestData.method, requestData.url, data);
    },

    logResponse(requestData: ApiLogData, data: unknown): void {
        logger.info('response', requestData.method, requestData.url, data);
    }
};
